interface FeaturesTableProps {
  tableFeatures: {
    feature: string
    description: string
  }[]
}

export default function FeaturesTable({ tableFeatures }: FeaturesTableProps) {
  return (
    <table className='flex flex-col xl:table'>
      <tbody>
        {tableFeatures ? (
          tableFeatures.map((tableFeature) => (
            <tr
              key={tableFeature.feature}
              className='bg-white dark:bg-slate-700 border-b border-gray-200 dark:border-gray-500 flex flex-col xl:table-row theme-transition'
            >
              <td className='text-gray-900 dark:text-gray-200 p-5 pb-0 xl:pb-5 theme-transition'>
                {tableFeature.feature}
              </td>
              <td className='text-gray-500 dark:text-gray-400 text-base mt-1 xl:mt-0 p-5 pt-0 xl:pt-5 theme-transition'>
                {tableFeature.description}
              </td>
            </tr>
          ))
        ) : (
          <td></td>
        )}
      </tbody>
    </table>
  )
}
